import type { IUser } from './user/types';
import type { DialogKeys } from './ui/types';
import type { IEdge, PageInfo } from './search/types';
import type { AppActionTypes } from './app/action-types';
import type { ISubscription } from './subscription/types';
import type { WorkspaceActionTypes } from './workspace/action-types';
import type { H5PEditorActionTypes } from './h5p-editor/action-types';
import type { ContentBrowserActionTypes } from './content-browser/action-types';

export * from './app/action-types';
export * from './workspace/action-types';
export * from './h5p-editor/action-types';
export * from './content-browser/action-types';

// constants
export const AUTH_LOGIN_REQUEST = 'AUTH_LOGIN_REQUEST';
export const AUTH_LOGIN_SUCCESS = 'AUTH_LOGIN_SUCCESS';
export const AUTH_LOGIN_FAILURE = 'AUTH_LOGIN_FAILURE';
export const AUTH_LOGOUT_REQUEST = 'AUTH_LOGOUT_REQUEST';
export const AUTH_LOGOUT_SUCCESS = 'AUTH_LOGOUT_SUCCESS';
export const AUTH_LOGOUT_FAILURE = 'AUTH_LOGOUT_FAILURE';
export const AUTH_GETSESSION_REQUEST = 'AUTH_GETSESSION_REQUEST';
export const AUTH_GETSESSION_SUCCESS = 'AUTH_GETSESSION_SUCCESS';
export const AUTH_GETSESSION_FAILURE = 'AUTH_GETSESSION_FAILURE';
export const AUTH_REGISTER_REQUEST = 'AUTH_REGISTER_REQUEST';
export const AUTH_REGISTER_SUCCESS = 'AUTH_REGISTER_SUCCESS';
export const AUTH_REGISTER_FAILURE = 'AUTH_REGISTER_FAILURE';
export const AUTH_RESENDEMAILVERIFICATION_REQUEST = 'AUTH_RESENDEMAILVERIFICATION_REQUEST';
export const AUTH_RESENDEMAILVERIFICATION_SUCCESS = 'AUTH_RESENDEMAILVERIFICATION_SUCCESS';
export const AUTH_RESENDEMAILVERIFICATION_FAILURE = 'AUTH_RESENDEMAILVERIFICATION_FAILURE';
export const AUTH_VERIFYEMAIL_REQUEST = 'AUTH_VERIFYEMAIL_REQUEST';
export const AUTH_VERIFYEMAIL_SUCCESS = 'AUTH_VERIFYEMAIL_SUCCESS';
export const AUTH_VERIFYEMAIL_FAILURE = 'AUTH_VERIFYEMAIL_FAILURE';
export const AUTH_REFRESHTOKEN_REQUEST = 'AUTH_REFRESHTOKEN_REQUEST';
export const AUTH_REFRESHTOKEN_SUCCESS = 'AUTH_REFRESHTOKEN_SUCCESS';
export const AUTH_REFRESHTOKEN_FAILURE = 'AUTH_REFRESHTOKEN_FAILURE';

export const ONBOARDING_STARTTOUR = 'ONBOARDING_STARTTOUR';
export const ONBOARDING_NEXTSTEP = 'ONBOARDING_NEXTSTEP';
export const ONBOARDING_PREVSTEP = 'ONBOARDING_PREVSTEP';
export const ONBOARDING_CLOSETOUR = 'ONBOARDING_CLOSETOUR';
export const ONBOARDING_INIT = 'ONBOARDING_INIT';
export const ONBOARDING_SETTOUR = 'ONBOARDING_SETTOUR';
export const SUBSCRIPTION_CANCEL_REQUEST = 'SUBSCRIPTION_CANCEL_REQUEST';
export const SUBSCRIPTION_CANCEL_SUCCESS = 'SUBSCRIPTION_CANCEL_SUCCESS';
export const SUBSCRIPTION_CANCEL_FAILURE = 'SUBSCRIPTION_CANCEL_FAILURE';
export const SUBSCRIPTION_GET_REQUEST = 'SUBSCRIPTION_GET_REQUEST';
export const SUBSCRIPTION_GET_SUCCESS = 'SUBSCRIPTION_GET_SUCCESS';
export const SUBSCRIPTION_GET_FAILURE = 'SUBSCRIPTION_GET_FAILURE';
export const SUBSCRIPTION_RESUME_REQUEST = 'SUBSCRIPTION_RESUME_REQUEST';
export const SUBSCRIPTION_RESUME_SUCCESS = 'SUBSCRIPTION_RESUME_SUCCESS';
export const SUBSCRIPTION_RESUME_FAILURE = 'SUBSCRIPTION_RESUME_FAILURE';
export const SUBSCRIPTION_TOGGLE_INTERVAL = 'SUBSCRIPTION_TOGGLE_INTERVAL';
export const SUBSCRIPTION_LINK_REQUEST = 'SUBSCRIPTION_LINK_REQUEST';
export const SUBSCRIPTION_LINK_SUCCESS = 'SUBSCRIPTION_LINK_SUCCESS';
export const SUBSCRIPTION_LINK_FAILURE = 'SUBSCRIPTION_LINK_FAILURE';
export const SUBSCRIPTION_UNLINK_REQUEST = 'SUBSCRIPTION_UNLINK_REQUEST';
export const SUBSCRIPTION_UNLINK_SUCCESS = 'SUBSCRIPTION_UNLINK_SUCCESS';
export const SUBSCRIPTION_UNLINK_FAILURE = 'SUBSCRIPTION_UNLINK_FAILURE';
export const SUBSCRIPTION_DATAPOPUPCLOSED = 'SUBSCRIPTION_DATAPOPUPCLOSED';

export const USER_UPDATE_SETTINGS_REQUEST = 'USER_UPDATE_SETTINGS_REQUEST';
export const USER_UPDATE_SETTINGS_SUCCESS = 'USER_UPDATE_SETTINGS_SUCCESS';
export const USER_UPDATE_SETTINGS_FAILURE = 'USER_UPDATE_SETTINGS_FAILURE';
export const USER_SOCKET_CONNECTED = 'USER_SOCKET_CONNECTED';
export const USER_SOCKET_DISCONNECTED = 'USER_SOCKET_DISCONNECTED';
export const USER_SOCKET_ERROR = 'USER_SOCKET_ERROR';
export const USER_DELETE_ACCOUNT_SUCCESS = 'USER_DELETE_ACCOUNT_SUCCESS';
export const USER_CHANGE_PASSWORD_SUCCESS = 'USER_CHANGE_PASSWORD_SUCCESS';
export const USER_CHANGE_EMAIL_SUCCESS = 'USER_CHANGE_EMAIL_SUCCESS';
export const USER_UPDATE_EMAIL_PREFERENCE_SUCCESS = 'USER_UPDATE_EMAIL_PREFERENCE_SUCCESS';

export const CONTENT_GET_USERCONTENT_REQUEST = 'CONTENT_GET_USERCONTENT_REQUEST';
export const CONTENT_GET_USERCONTENT_SUCCESS = 'CONTENT_GET_USERCONTENT_SUCCESS';
export const CONTENT_GET_USERCONTENT_FAILURE = 'CONTENT_GET_USERCONTENT_FAILURE';
export const CONTENT_DELETE_REQUEST = 'CONTENT_DELETE_REQUEST';
export const CONTENT_DELETE_SUCCESS = 'CONTENT_DELETE_SUCCESS';
export const CONTENT_DELETE_FAILURE = 'CONTENT_DELETE_FAILURE';
export const CONTENT_GET_CONTENT_REQUEST = 'CONTENT_GET_CONTENT_REQUEST';
export const CONTENT_GET_CONTENT_SUCCESS = 'CONTENT_GET_CONTENT_SUCCESS';
export const CONTENT_GET_CONTENT_FAILURE = 'CONTENT_GET_CONTENT_FAILURE';
export const CONTENT_SET_QUERY = 'CONTENT_SET_QUERY';
export const CONTENT_DOWNLOADCONTENT_REQUEST = 'CONTENT_DOWNLOADCONTENT_REQUEST';
export const CONTENT_DOWNLOADCONTENT_SUCCESS = 'CONTENT_DOWNLOADCONTENT_SUCCESS';
export const CONTENT_DOWNLOADCONTENT_FAILURE = 'CONTENT_DOWNLOADCONTENT_FAILURE';

export const DEPLOYMENTS_GET_REQUEST = 'DEPLOYMENTS_GET_REQUEST';
export const DEPLOYMENTS_GET_SUCCESS = 'DEPLOYMENTS_GET_SUCCESS';
export const DEPLOYMENTS_GET_FAILURE = 'DEPLOYMENTS_GET_FAILURE';
export const DEPLOYMENTS_CREATE_UPDATE_REQUEST = 'DEPLOYMENTS_CREATE_UPDATE_REQUEST';
export const DEPLOYMENTS_CREATE_UPDATE_SUCCESS = 'DEPLOYMENTS_CREATE_UPDATE_SUCCESS';
export const DEPLOYMENTS_CREATE_UPDATE_FAILURE = 'DEPLOYMENTS_CREATE_UPDATE_FAILURE';
export const DEPLOYMENTS_GENERATESAMPLEDATA = 'DEPLOYMENTS_GENERATESAMPLEDATA';
export const DEPLOYMENT_UPDATE = 'DEPLOYMENT_UPDATE';
export const INSIGHTS_UPDATE_FILTER = 'INSIGHTS_UPDATE_FILTER';

export const RUN_GET_REQUEST = 'RUN_GET_REQUEST';
export const RUN_GET_SUCCESS = 'RUN_GET_SUCCESS';
export const RUN_GET_FAILURE = 'RUN_GET_FAILURE';
export const RUN_CREATE_UPDATE_REQUEST = 'RUN_CREATE_UPDATE_REQUEST';
export const RUN_CREATE_UPDATE_SUCCESS = 'RUN_CREATE_UPDATE_SUCCESS';
export const RUN_CREATE_UPDATE_FAILURE = 'RUN_CREATE_UPDATE_FAILURE';
export const RUN_GET_ANALYTICS_REQUEST = 'RUN_GET_ANALYTICS_REQUEST';
export const RUN_GET_ANALYTICS_SUCCESS = 'RUN_GET_ANALYTICS_SUCCESS';
export const RUN_GET_ANALYTICS_FAILURE = 'RUN_GET_ANALYTICS_FAILURE';
export const RUN_UPDATE_PAUSED = 'RUN_UPDATE_PAUSED';
export const RUN_XAPI_STATEMENT_RECEIVED = 'RUN_XAPI_STATEMENT_RECEIVED';
export const RUN_ADD_USER = 'RUN_ADD_USER';
export const RUN_UPDATE_USER = 'RUN_UPDATE_USER';
export const RUN_ADD_ANSWER = 'RUN_ADD_ANSWER';

export const CONTENT_EXPORT_REQUEST = 'CONTENT_EXPORT_REQUEST';
export const CONTENT_EXPORT_UPDATE = 'CONTENT_EXPORT_UPDATE';
export const CONTENT_EXPORT_SUCCESS = 'CONTENT_EXPORT_SUCCESS';
export const CONTENT_EXPORT_FAILURE = 'CONTENT_EXPORT_FAILURE';
export const CONTENT_PUBLISH_REQUEST = 'CONTENT_PUBLISH_REQUEST';
export const CONTENT_PUBLISH_SUCCESS = 'CONTENT_PUBLISH_SUCCESS';
export const CONTENT_PUBLISH_FAILURE = 'CONTENT_PUBLISH_FAILURE';
export const CONTENT_UNPUBLISH_REQUEST = 'CONTENT_UNPUBLISH_REQUEST';
export const CONTENT_UNPUBLISH_SUCCESS = 'CONTENT_UNPUBLISH_SUCCESS';
export const CONTENT_UNPUBLISH_FAILURE = 'CONTENT_UNPUBLISH_FAILURE';
export const CONTENT_LOADPLAYERCONTENT_REQUEST = 'CONTENT_LOADPLAYERCONTENT_REQUEST';
export const CONTENT_LOADPLAYERCONTENT_SUCCESS = 'CONTENT_LOADPLAYERCONTENT_SUCCESS';
export const CONTENT_LOADPLAYERCONTENT_FAILURE = 'CONTENT_LOADPLAYERCONTENT_FAILURE';
export const CONTENT_SELECT_CONTENT = 'CONTENT_SELECT_CONTENT';
export const CONTENT_UNSELECT_CONTENT = 'CONTENT_UNSELECT_CONTENT';
export const CONTENT_SET_SELECTED_CONTENT = 'CONTENT_SET_SELECTED_CONTENT';

export const CONTENTEDITOR_GET_CONTENT_REQUEST = 'CONTENTEDITOR_GET_CONTENT_REQUEST';
export const CONTENTEDITOR_GET_CONTENT_SUCCESS = 'CONTENTEDITOR_GET_CONTENT_SUCCESS';
export const CONTENTEDITOR_GET_CONTENT_FAILURE = 'CONTENTEDITOR_GET_CONTENT_FAILURE';
export const CONTENTEDITOR_UPDATE_CONTENT = 'CONTENTEDITOR_UPDATE_CONTENT';
export const CONTENTEDITOR_SETSHOWEXPORTDIALOG = 'CONTENTEDITOR_SETSHOWEXPORTDIALOG';
export const CONTENTEDITOR_RESETCONTENT = 'CONTENTEDITOR_RESETCONTENT';
export const CONTENTEDITOR_LOADEDITORCONTENT_REQUEST = 'CONTENTEDITOR_LOADEDITORCONTENT_REQUEST';
export const CONTENTEDITOR_LOADEDITORCONTENT_SUCCESS = 'CONTENTEDITOR_LOADEDITORCONTENT_SUCCESS';
export const CONTENTEDITOR_LOADEDITORCONTENT_FAILURE = 'CONTENTEDITOR_LOADEDITORCONTENT_FAILURE';
export const CONTENTEDITOR_UPDATEEDITORCONTENT_REQUEST =
  'CONTENTEDITOR_UPDATEEDITORCONTENT_REQUEST';
export const CONTENTEDITOR_UPDATEEDITORCONTENT_SUCCESS =
  'CONTENTEDITOR_UPDATEEDITORCONTENT_SUCCESS';
export const CONTENTEDITOR_UPDATEEDITORCONTENT_FAILURE =
  'CONTENTEDITOR_UPDATEEDITORCONTENT_FAILURE';
export const CONTENTEDITOR_ONSAVEERROR = 'CONTENTEDITOR_ONSAVEERROR';
export const CONTENTEDITOR_ONLOADED = 'CONTENTEDITOR_ONLOADED';
export const CONTENTEDITOR_ONSAVED = 'CONTENTEDITOR_ONSAVED';

export const FLOW_GETFLOW_REQUEST = 'FLOW_GETFLOW_REQUEST';
export const FLOW_GETFLOW_SUCCESS = 'FLOW_GETFLOW_SUCCESS';
export const FLOW_GETFLOW_FAILURE = 'FLOW_GETFLOW_FAILURE';
export const FLOW_CREATEFLOW_REQUEST = 'FLOW_CREATEFLOW_REQUEST';
export const FLOW_CREATEFLOW_SUCCESS = 'FLOW_CREATEFLOW_SUCCESS';
export const FLOW_CREATEFLOW_FAILURE = 'FLOW_CREATEFLOW_FAILURE';
export const FLOW_DELETECONTENTID = 'FLOW_DELETECONTENTID';
export const FLOW_UPDATEFLOW_REQUEST = 'FLOW_UPDATEFLOW_REQUEST';
export const FLOW_UPDATEFLOW_SUCCESS = 'FLOW_UPDATEFLOW_SUCCESS';
export const FLOW_UPDATEFLOW_FAILURE = 'FLOW_UPDATEFLOW_FAILURE';
export const FLOW_DELETEFLOW_REQUEST = 'FLOW_DELETEFLOW_REQUEST';
export const FLOW_DELETEFLOW_SUCCESS = 'FLOW_DELETEFLOW_SUCCESS';
export const FLOW_DELETEFLOW_FAILURE = 'FLOW_DELETEFLOW_FAILURE';
export const FLOW_GETFLOWPAGE_REQUEST = 'FLOW_GETFLOWPAGE_REQUEST';
export const FLOW_GETFLOWPAGE_SUCCESS = 'FLOW_GETFLOWPAGE_SUCCESS';
export const FLOW_GETFLOWPAGE_FAILURE = 'FLOW_GETFLOWPAGE_FAILURE';
export const FLOW_ADDCONTENTID = 'FLOW_ADDCONTENTID';
export const FLOW_SETPREVIEWCONTENTID = 'FLOW_SETPREVIEWCONTENTID';
export const FLOW_RESETFLOW = 'FLOW_RESETFLOW';
export const FLOW_SETTAB = 'FLOW_SETTAB';
export const FLOW_SETQUERY = 'FLOW_SETQUERY';
export const FLOW_PERSISTCONTENTIDS = 'FLOW_PERSISTCONTENTIDS';
export const FLOW_SELECTCONTENTID = 'FLOW_SELECTCONTENTID';
export const FLOW_MOVECONTENTIDUPWARD = 'FLOW_MOVECONTENTIDUPWARD';
export const FLOW_MOVECONTENTIDDOWNWARD = 'FLOW_MOVECONTENTIDDOWNWARD';
export const FLOW_UPDATEFLOW = 'FLOW_UPDATEFLOW';

export const PUBLICCONTENT_GETPAGE_REQUEST = 'PUBLICCONTENT_GETPAGE_REQUEST';
export const PUBLICCONTENT_GETPAGE_SUCCESS = 'PUBLICCONTENT_GETPAGE_SUCCESS';
export const PUBLICCONTENT_GETPAGE_FAILURE = 'PUBLICCONTENT_GETPAGE_FAILURE';
export const PUBLICCONTENT_TOGGLEFILTERSIDEBAR = 'PUBLICCONTENT_TOGGLEFILTERSIDEBAR';
export const PUBLICCONTENT_SETFILTER = 'PUBLICCONTENT_SETFILTER';

export const NOTIFICATIONS_ADD = 'NOTIFICATIONS_ADD';
export const NOTIFICATIONS_REMOVE = 'NOTIFICATIONS_REMOVE';
export const NOTIFICATIONS_DISMISS = 'NOTIFICATIONS_DISMISS';

export const JOBS_GETJOB_REQUEST = 'JOBS_GETJOB_REQUEST';
export const JOBS_GETJOB_SUCCESS = 'JOBS_GETJOB_SUCCESS';
export const JOBS_GETJOB_FAILURE = 'JOBS_GETJOB_FAILURE';
export const JOBS_STARTPOLLING = 'JOBS_STARTPOLLING';
export const JOBS_STOPPOLLING = 'JOBS_STOPPOLLING';

export const UI_RESET_ERRORS = 'UI_RESET_ERRORS';
export const UI_CHANGE_LANGUAGE = 'UI_CHANGE_LANGUAGE';
export const UI_SHOW_DIALOG = 'UI_SHOW_DIALOG';
export const UI_HIDE_DIALOG = 'UI_HIDE_DIALOG';
export const UI_NAVIGATE = 'UI_NAVIGATE';
export const UI_SET_VIEW = 'UI_SET_VIEW';
export const UI_CLIPBOARD_CUT = 'UI_CLIPBOARD_CUT';

export const WEBSOCKET_ONCONNECT = 'WEBSOCKET_ONCONNECT';
export const WEBSOCKET_ONERROR = 'WEBSOCKET_ONERROR';
export const WEBSOCKET_CONNECT_REQUEST = 'WEBSOCKET_CONNECT_REQUEST';
export const WEBSOCKET_JOIN_REQUEST = 'WEBSOCKET_JOIN_REQUEST';
export const WEBSOCKET_JOIN_SUCCESS = 'WEBSOCKET_JOIN_SUCCESS';
export const WEBSOCKET_JOIN_FAILURE = 'WEBSOCKET_JOIN_FAILURE';
export const WEBSOCKET_LEAVE_REQUEST = 'WEBSOCKET_LEAVE_REQUEST';
export const WEBSOCKET_LEAVE_SUCCESS = 'WEBSOCKET_LEAVE_SUCCESS';

export const XAPI_STATEMENT_RECEIVED = 'XAPI_STATEMENT_RECEIVED';
export const XAPI_STATEMENT_SEND = 'XAPI_STATEMENT_SEND';

export const APP_GETSIGNEDUPLOADURL_REQUEST = 'APP_GETSIGNEDUPLOADURL_REQUEST';
export const APP_GETSIGNEDUPLOADURL_SUCCESS = 'APP_GETSIGNEDUPLOADURL_SUCCESS';
export const APP_GETSIGNEDUPLOADURL_FAILURE = 'APP_GETSIGNEDUPLOADURL_FAILURE';
export const APP_UPLOAD_REQUEST = 'APP_UPLOAD_REQUEST';
export const APP_UPLOAD_SUCCESS = 'APP_UPLOAD_SUCCESS';
export const APP_UPLOAD_FAILURE = 'APP_UPLOAD_FAILURE';

export const FOLDERS_SETCURRENTFOLDER = 'FOLDERS_SETCURRENTFOLDER';
export const FOLDERS_CREATEFOLDER_REQUEST = 'FOLDERS_CREATEFOLDER_REQUEST';
export const FOLDERS_CREATEFOLDER_SUCCESS = 'FOLDERS_CREATEFOLDER_SUCCESS';
export const FOLDERS_CREATEFOLDER_FAILURE = 'FOLDERS_CREATEFOLDER_FAILURE';
export const FOLDERS_DELETEFOLDER_REQUEST = 'FOLDERS_DELETEFOLDER_REQUEST';
export const FOLDERS_DELETEFOLDER_SUCCESS = 'FOLDERS_DELETEFOLDER_SUCCESS';
export const FOLDERS_DELETEFOLDER_FAILURE = 'FOLDERS_DELETEFOLDER_FAILURE';
export const FOLDERS_SELECTFOLDERS = 'FOLDERS_SELECTFOLDERS';
export const FOLDERS_SELECTCONTENT = 'FOLDERS_SELECTCONTENT';
export const FOLDERS_OPENEDITDIALOG = 'FOLDERS_OPENEDITDIALOG';
export const FOLDERS_UPDATEFOLDERS_REQUEST = 'FOLDERS_UPDATEFOLDERS_REQUEST';
export const FOLDERS_UPDATEFOLDERS_SUCCESS = 'FOLDERS_UPDATEFOLDERS_SUCCESS';
export const FOLDERS_UPDATEFOLDERS_FAILURE = 'FOLDERS_UPDATEFOLDERS_FAILURE';
export const FOLDERS_CLOSEEDITDIALOG = 'FOLDERS_CLOSEEDITDIALOG';
export const FOLDERS_GETFOLDERS_REQUEST = 'FOLDER_GETFOLDERS_REQUEST';
export const FOLDERS_GETFOLDERS_SUCCESS = 'FOLDER_GETFOLDERS_SUCCESS';
export const FOLDERS_GETFOLDERS_FAILURE = 'FOLDER_GETFOLDERS_FAILURE';
export const FOLDERS_SELECTALLINCURRENTFOLDER = 'FOLDERS_SELECTALLINCURRENTFOLDER';
export const FOLDERS_ADD_CONTENT_TO_FOLDER = 'FOLDERS_ADD_CONTENT_TO_FOLDER';
export const FOLDERS_REMOVE_CONTENT_FROM_FOLDER = 'FOLDERS_REMOVE_CONTENT_FROM_FOLDER';
export const FOLDERS_GET_USER_ROOT_FOLDERS_REQUEST = 'FOLDERS_GET_USER_ROOT_FOLDERS_REQUEST';
export const FOLDERS_GET_USER_ROOT_FOLDERS_SUCCESS = 'FOLDERS_GET_USER_ROOT_FOLDERS_SUCCESS';
export const FOLDERS_GET_USER_ROOT_FOLDERS_FAILURE = 'FOLDERS_GET_USER_ROOT_FOLDERS_FAILURE';
export const FOLDERS_FOLDER_CREATED = 'FOLDERS_FOLDER_CREATED';
export const FOLDERS_SET_EDIT_FOLDER = 'FOLDERS_SET_EDIT_FOLDER';
export const FOLDERS_SET_SELECTED_FOLDERS = 'FOLDERS_SET_SELECTED_FOLDERS';
export const FOLDERS_CREATE_SUCCESS = 'FOLDERS_CREATE_SUCCESS';
export const FOLDERS_DELETE_SUCCESS = 'FOLDERS_DELETE_SUCCESS';
export const FOLDER_CREATE_REQUEST = 'FOLDER_CREATE_REQUEST';
export const FOLDER_CREATE_SUCCESS = 'FOLDER_CREATE_SUCCESS';
export const FOLDER_CREATE_FAILURE = 'FOLDER_CREATE_FAILURE';
export const FOLDER_UPDATE_SUCCESS = 'FOLDER_UPDATE_SUCCESS';

export const FOLDERS_REMOVE_CONTENT_SUCCESS = 'FOLDERS_REMOVE_CONTENT_SUCCESS';
export const FOLDERS_ADD_CONTENT_TO_FOLDER_SUCCESS = 'FOLDERS_ADD_CONTENT_TO_FOLDER_SUCCESS';
export const FOLDERS_SET_FOLDERID_TO_ADD_CONTENT = 'FOLDERS_SET_FOLDERID_TO_ADD_CONTENT';
export const FOLDERS_CUT_AND_PASTE_REQUEST = 'FOLDERS_CUT_AND_PASTE_REQUEST';
export const FOLDERS_CUT_AND_PASTE_SUCCESS = 'FOLDERS_CUT_AND_PASTE_SUCCESS';
export const FOLDERS_CUT_AND_PASTE_FAILURE = 'FOLDERS_CUT_AND_PASTE_FAILURE';

export const CONTENTEDITOR_OPEN = 'CONTENTEDITOR_OPEN';
export const CONTENTEDITOR_CLOSE = 'CONTENTEDITOR_CLOSE';
export const CONTENTEDITOR_SETCONTENTPARAMS = 'CONTENTEDITOR_SETCONTENTPARAMS';
export const CONTENTEDITOR_CHANGEMODE = 'CONTENTEDITOR_CHANGEMODE';

export const CONTENT_ADD_DOWNLOAD = 'CONTENT_ADD_DOWNLOAD';
export const CONTENT_UPDATE_DOWNLOAD = 'CONTENT_UPDATE_DOWNLOAD';

export const APP_INIT_REQUEST = 'APP_INIT_REQUEST';
export const APP_INIT_SUCCESS = 'APP_INIT_SUCCESS';
export const APP_INIT_FAILURE = 'APP_INIT_FAILURE';
// actions

export interface IAppInitRequestAction {
  type: typeof APP_INIT_REQUEST;
}

export interface IAppInitSuccessAction {
  type: typeof APP_INIT_SUCCESS;
  payload: {
    versions: {
      client: string;
    };
    features: {
      publicContent: boolean;
      likePublicContent: boolean;
      groups: boolean;
      subscription: boolean;
    };
  };
}

export interface IAppInitFailureAction {
  type: typeof APP_INIT_FAILURE;
  payload: Error;
}
export interface IAddContentDownload {
  type: typeof CONTENT_ADD_DOWNLOAD;
  payload: {
    contentIds: string[];
  };
}

export interface IUpdateContentDownload {
  type: typeof CONTENT_UPDATE_DOWNLOAD;
  payload: {
    contentId: string;
    state: 'loading' | 'success' | 'error';
    loaded: number;
  };
}

export interface IContentEditorSetContentParamsAction {
  type: typeof CONTENTEDITOR_SETCONTENTPARAMS;
  payload: {
    contentId: string;
    params: string;
    metadata: any;
    contentHash: string;
  };
}

export interface IContentEditorOpenAction {
  type: typeof CONTENTEDITOR_OPEN;
  payload: {
    contentId: string;
  };
}

export interface IContentEditorCloseAction {
  type: typeof CONTENTEDITOR_CLOSE;
}

export interface IFoldersCutAndPasteRequestAction {
  type: typeof FOLDERS_CUT_AND_PASTE_REQUEST;
  payload: {
    cutFolderId: string;
    pasteFolderId: string;
    contentIds: string[];
  };
}

export interface IFoldersCutAndPasteSuccessAction {
  type: typeof FOLDERS_CUT_AND_PASTE_SUCCESS;
  payload: {
    cutFolderId: string;
    pasteFolderId: string;
    contentIds: string[];
  };
}

export interface IFoldersCutAndPasteFailureAction {
  type: typeof FOLDERS_CUT_AND_PASTE_FAILURE;
  payload: Error;
}

export interface IUIClipboardCutAction {
  type: typeof UI_CLIPBOARD_CUT;
  payload: {
    cutFromFolderId: string;
  };
}

export interface IUISetViewAction {
  type: typeof UI_SET_VIEW;
  payload: {
    view: 'grid' | 'list';
  };
}

export interface IFoldersSetFolderIdToAddContentAction {
  type: typeof FOLDERS_SET_FOLDERID_TO_ADD_CONTENT;
  payload: {
    folderId: string;
  };
}
export interface IUserUpdateEmailPreferenceSuccessAction {
  type: typeof USER_UPDATE_EMAIL_PREFERENCE_SUCCESS;
  payload: { newsletter: boolean };
}

export interface IUserChangeEmailSuccessAction {
  type: typeof USER_CHANGE_EMAIL_SUCCESS;
  payload: { email: string };
}

export interface IDeploymentUpdateAction {
  type: typeof DEPLOYMENT_UPDATE;
  payload: {
    paused: boolean;
  };
}

export interface IUserChangePasswordSuccessAction {
  type: typeof USER_CHANGE_PASSWORD_SUCCESS;
}

export interface IUserDeleteAccountSuccessAction {
  type: typeof USER_DELETE_ACCOUNT_SUCCESS;
}

export interface IFoldersAddContentToFolderSuccessAction {
  type: typeof FOLDERS_ADD_CONTENT_TO_FOLDER_SUCCESS;
  payload: {
    folderId: string;
    contentIds: string[];
  };
}

export interface IFoldersRemoveContentSuccessAction {
  type: typeof FOLDERS_REMOVE_CONTENT_SUCCESS;
  payload: {
    folderId: string;
    contentIds: string[];
  };
}
export interface IFoldersCreateSuccessAction {
  type: typeof FOLDERS_CREATE_SUCCESS;
  payload: {};
}
export interface IFoldersSetSelectedFoldersAction {
  type: typeof FOLDERS_SET_SELECTED_FOLDERS;
  payload: {
    folderIds: string[];
  };
}

export interface IFoldersDeleteSuccessAction {
  type: typeof FOLDERS_DELETE_SUCCESS;
  payload: {
    folderIds: string[];
  };
}

export interface IFolderCreateRequestAction {
  type: typeof FOLDER_CREATE_REQUEST;
  payload: {
    tempId: string;
    name: string;
    parent_id: string;
    workspace_id: string;
    color?: string;
  };
}

export interface IFolderCreateSuccessAction {
  type: typeof FOLDER_CREATE_SUCCESS;
  payload: {
    tempId: string;
    id: string;
    name: string;
    parent_id: string;
    workspace_id: string;
    color?: string;
  };
}

export interface IFolderCreateFailureAction {
  type: typeof FOLDER_CREATE_FAILURE;
  payload: {
    tempId: string;
    error: Error;
  };
}

export interface IFolderUpdateSuccessAction {
  type: typeof FOLDER_UPDATE_SUCCESS;
  payload: {
    id: string;
    name: string;
    color: string;
  };
}

export interface IFoldersSetEditFolderAction {
  type: typeof FOLDERS_SET_EDIT_FOLDER;
  payload: {
    id: string;
    name: string;
  };
}
export interface IFoldersFolderCreatedAction {
  type: typeof FOLDERS_FOLDER_CREATED;
  payload: {
    name: string;
  };
}

export interface IFoldersGetUserRootFoldersRequestAction {
  type: typeof FOLDERS_GET_USER_ROOT_FOLDERS_REQUEST;
}

export interface IFoldersGetUserRootFoldersSuccessAction {
  type: typeof FOLDERS_GET_USER_ROOT_FOLDERS_SUCCESS;
  payload: {};
}

export interface IFoldersGetUserRootFoldersFailureAction {
  type: typeof FOLDERS_GET_USER_ROOT_FOLDERS_FAILURE;
  payload: Error;
}

export interface IFoldersGetFoldersRequestAction {
  type: typeof FOLDERS_GETFOLDERS_REQUEST;
  payload: {
    folderIds: string[];
  };
}

export interface IFoldersGetFoldersSuccessAction {
  type: typeof FOLDERS_GETFOLDERS_SUCCESS;
  payload: {};
}

export interface IFoldersGetFoldersFailureAction {
  type: typeof FOLDERS_GETFOLDERS_FAILURE;
  payload: Error;
}

export interface IUINavigateAction {
  type: typeof UI_NAVIGATE;
  payload: {
    path: string;
  };
}
export interface IFoldersRemoveContentFromFolderAction {
  type: typeof FOLDERS_REMOVE_CONTENT_FROM_FOLDER;
  payload: {
    folderId: string;
    contentIds: string[];
  };
}

export interface IUIShowDialogAction {
  type: typeof UI_SHOW_DIALOG;
  payload: {
    key: DialogKeys;
    context?: string;
  };
}

export interface IUIHideDialogAction {
  type: typeof UI_HIDE_DIALOG;
  payload: {
    key: DialogKeys;
  };
}

export interface IFoldersAddContentToFolderAction {
  type: typeof FOLDERS_ADD_CONTENT_TO_FOLDER;
  payload: {
    folderId: string;
    contentIds: string[];
  };
}

export interface IContentSelectContentAction {
  type: typeof CONTENT_SELECT_CONTENT;
  payload: {
    contentId: string;
  };
}

export interface IContentUnselectContentAction {
  type: typeof CONTENT_UNSELECT_CONTENT;
  payload: {
    contentId: string;
  };
}

export interface IContentSetSelectedContentAction {
  type: typeof CONTENT_SET_SELECTED_CONTENT;
  payload: {
    contentIds: string[];
  };
}

export interface IFoldersSelectAllInCurrentFolderAction {
  type: typeof FOLDERS_SELECTALLINCURRENTFOLDER;
}

export interface IFoldersCloseEditDialogAction {
  type: typeof FOLDERS_CLOSEEDITDIALOG;
}

export interface IFoldersUpdateFolderRequestAction {
  type: typeof FOLDERS_UPDATEFOLDERS_REQUEST;
  payload: {};
}

export interface IFoldersUpdateFolderSuccessAction {
  type: typeof FOLDERS_UPDATEFOLDERS_SUCCESS;
  payload: {};
}

export interface IFoldersUpdateFolderFailureAction {
  type: typeof FOLDERS_UPDATEFOLDERS_FAILURE;
  payload: Error;
}

export interface IFoldersOpenEditDialogAction {
  type: typeof FOLDERS_OPENEDITDIALOG;
  payload: {
    folderId: string;
  };
}

export interface IFoldersSelectFolderAction {
  type: typeof FOLDERS_SELECTFOLDERS;
  payload: {
    folderId: string;
  };
}

export interface IFoldersSelectContentAction {
  type: typeof FOLDERS_SELECTCONTENT;
  payload: {
    contentId: string;
  };
}

export interface IFoldersCreateFolderRequestAction {
  type: typeof FOLDERS_CREATEFOLDER_REQUEST;
  payload: {
    name: string;
    parentId: string;
  };
}

export interface IFoldersCreateFolderSuccessAction {
  type: typeof FOLDERS_CREATEFOLDER_SUCCESS;
  payload: {};
}

export interface IFoldersCreateFolderFailureAction {
  type: typeof FOLDERS_CREATEFOLDER_FAILURE;
  payload: Error;
}

export interface IFoldersSetCurrentFolderAction {
  type: typeof FOLDERS_SETCURRENTFOLDER;
  payload: {
    folderId: string;
  };
}

export interface IFoldersDeleteFolderRequestAction {
  type: typeof FOLDERS_DELETEFOLDER_REQUEST;
  payload: {
    folderIds: string[];
  };
}

export interface IFoldersDeleteFolderSuccessAction {
  type: typeof FOLDERS_DELETEFOLDER_SUCCESS;
  payload: {
    folderIds: string[];
  };
}

export interface IFoldersDeleteFolderFailureAction {
  type: typeof FOLDERS_DELETEFOLDER_FAILURE;
  payload: Error;
}

export interface IWebsocketJoinRequestAction {
  type: typeof WEBSOCKET_JOIN_REQUEST;
  payload: {
    domain: string;
    room: string;
    access: string;
  };
}

export interface IAppGetSignedUploadUrlRequestAction {
  type: typeof APP_GETSIGNEDUPLOADURL_REQUEST;
  payload: {
    name: string;
    type: string;
  };
}

export interface IAppGetSignedUploadUrlSuccessAction {
  type: typeof APP_GETSIGNEDUPLOADURL_SUCCESS;
  payload: {
    name: string;
    type: string;
    signedUploadUrl: string;
    url: string;
  };
}

export interface IAppGetSignedUploadUrlFailureAction {
  type: typeof APP_GETSIGNEDUPLOADURL_FAILURE;
  payload: {
    name: string;
    type: string;
  };
  error: Error;
}

export interface IWebsocketJoinSuccessAction {
  type: typeof WEBSOCKET_JOIN_SUCCESS;
  payload: {
    domain: string;
    room: string;
    access: string;
  };
}

export interface IWebsocketLeaveSuccessAction {
  type: typeof WEBSOCKET_LEAVE_SUCCESS;
  payload: {
    domain: string;
    room: string;
    access: string;
  };
}

export interface IWebsocketOnConnectAction {
  type: typeof WEBSOCKET_ONCONNECT;
  payload: { socketId: string };
}

export interface IWebsocketOnErrorAction {
  type: typeof WEBSOCKET_ONERROR;
  payload: Error;
}

export interface IWebsocketConnectRequestAction {
  type: typeof WEBSOCKET_CONNECT_REQUEST;
}

export interface IAuthLoginRequestAction {
  type: typeof AUTH_LOGIN_REQUEST;
  payload: {
    email: string;
  };
}

export interface IAuthGetSessionRequestAction {
  type: typeof AUTH_GETSESSION_REQUEST;
}

export interface IAuthGetSessionSuccessAction {
  type: typeof AUTH_GETSESSION_SUCCESS;
  payload: {
    user: IUser;
  };
}

export interface IAuthLoginSuccessAction {
  type: typeof AUTH_LOGIN_SUCCESS;
  payload: {};
}

export interface IAutLogoutRequestAction {
  type: typeof AUTH_LOGOUT_REQUEST;
}

export interface IAutLogoutSuccessAction {
  type: typeof AUTH_LOGOUT_SUCCESS;
}

export interface IAutLogoutFailureAction {
  type: typeof AUTH_LOGOUT_FAILURE;
}

export interface IAuthGetSessionFailureAction {
  type: typeof AUTH_GETSESSION_FAILURE;
}

export interface IAuthLoginFailureAction {
  type: typeof AUTH_LOGIN_FAILURE;
  payload: {
    errorCode: string;
  };
}

export interface IAuthRegisterRequestAction {
  type: typeof AUTH_REGISTER_REQUEST;
  payload: {
    email: string;
    username: string;
  };
}

export interface IAuthRegisterSuccessAction {
  type: typeof AUTH_REGISTER_SUCCESS;
  payload: {};
}

export interface IAuthRegisterFailureAction {
  type: typeof AUTH_REGISTER_FAILURE;
  payload: {
    email: string;
    username: string;
  };
  errorCode: string;
}

export interface IAuthVerifyEmailRequestAction {
  type: typeof AUTH_VERIFYEMAIL_REQUEST;
  payload: {
    verificationId: string;
  };
}

export interface IAuthVerifyEmailSuccessAction {
  type: typeof AUTH_VERIFYEMAIL_SUCCESS;
}

export interface IAuthVerifyEmailFailureAction {
  type: typeof AUTH_VERIFYEMAIL_FAILURE;
  errorCode: string;
}

export interface IAuthResendEmailVerificationRequestAction {
  type: typeof AUTH_RESENDEMAILVERIFICATION_REQUEST;
  payload: {
    email: string;
  };
}

export interface IAuthResendEmailVerificationSuccessAction {
  type: typeof AUTH_RESENDEMAILVERIFICATION_SUCCESS;
  payload: {
    email: string;
  };
}

export interface IAuthResendEmailVerificationFailureAction {
  type: typeof AUTH_RESENDEMAILVERIFICATION_FAILURE;
  payload: {
    email: string;
  };
  errorCode: string;
}

export interface IAuthRefreshTokenRequestAction {
  type: typeof AUTH_REFRESHTOKEN_REQUEST;
}

export interface IAuthRefreshTokenSuccessAction {
  type: typeof AUTH_REFRESHTOKEN_SUCCESS;
  payload: {
    user: IUser;
  };
}

export interface IAuthRefreshTokenFailureAction {
  type: typeof AUTH_REFRESHTOKEN_FAILURE;
}

export interface IOnboardingStartTourAction {
  type: typeof ONBOARDING_STARTTOUR;
}

export interface IOnboardingNextStepAction {
  type: typeof ONBOARDING_NEXTSTEP;
}

export interface IOnboardingPrevStepAction {
  type: typeof ONBOARDING_PREVSTEP;
}

export interface IOnboardingCloseTourAction {
  type: typeof ONBOARDING_CLOSETOUR;
}

export interface IOnboardingInitAction {
  type: typeof ONBOARDING_INIT;
  payload: {
    onboardingComplete: boolean;
  };
}

export interface IOnboardingSetTourAction {
  type: typeof ONBOARDING_SETTOUR;
  payload: {
    tour: 'onboarding' | 'deploy' | 'publish' | 'embed' | 'export' | 'groups';
  };
}

export interface ISubscriptionCancelRequestAction {
  type: typeof SUBSCRIPTION_CANCEL_REQUEST;
}

export interface ISubscriptionCancelSuccessAction {
  type: typeof SUBSCRIPTION_CANCEL_SUCCESS;
  payload: {
    subscription: ISubscription;
  };
}

export interface ISubscriptionCancelFailureAction {
  type: typeof SUBSCRIPTION_CANCEL_FAILURE;
  payload: Error;
}

export interface ISubscriptionResumeRequestAction {
  type: typeof SUBSCRIPTION_RESUME_REQUEST;
}

export interface ISubscriptionResumeSuccessAction {
  type: typeof SUBSCRIPTION_RESUME_SUCCESS;
  payload: {
    subscription: ISubscription;
  };
}

export interface ISubscriptionResumeFailureAction {
  type: typeof SUBSCRIPTION_RESUME_FAILURE;
  payload: Error;
}

export interface ISubscriptionGetRequestAction {
  type: typeof SUBSCRIPTION_GET_REQUEST;
}

export interface ISubscriptionGetSuccessAction {
  type: typeof SUBSCRIPTION_GET_SUCCESS;
  payload: {
    subscription: ISubscription;
  };
}

export interface ISubscriptionGetFailureAction {
  type: typeof SUBSCRIPTION_GET_FAILURE;
  payload: Error;
}

export interface ISubscriptionToggleIntervalAction {
  type: typeof SUBSCRIPTION_TOGGLE_INTERVAL;
}

export interface ISubscriptionLinkRequestAction {
  type: typeof SUBSCRIPTION_LINK_REQUEST;
  payload: {
    subscriptionId: string;
  };
}

export interface ISubscriptionLinkSuccessAction {
  type: typeof SUBSCRIPTION_LINK_SUCCESS;
  payload: {
    subscription: ISubscription;
  };
}

export interface ISubscriptionLinkFailureAction {
  type: typeof SUBSCRIPTION_LINK_FAILURE;
  errorCode: string;
}

export interface ISubscriptionUnlinkRequestAction {
  type: typeof SUBSCRIPTION_UNLINK_REQUEST;
  payload: {
    subscriptionId: string;
  };
}

export interface ISubscriptionUnlinkSuccessAction {
  type: typeof SUBSCRIPTION_UNLINK_SUCCESS;
}

export interface ISubscriptionUnlinkFailureAction {
  type: typeof SUBSCRIPTION_UNLINK_FAILURE;
  errorCode: string;
}

export interface ISubscriptionDataPopupClosedAction {
  type: typeof SUBSCRIPTION_DATAPOPUPCLOSED;
  payload: {
    id?: string;
    reference?: string;
  };
}
export interface IUserUpdateSettingsRequestAction {
  type: typeof USER_UPDATE_SETTINGS_REQUEST;
  payload: Partial<IUser>;
}

export interface IUserUpdateSettingsSuccessAction {
  type: typeof USER_UPDATE_SETTINGS_SUCCESS;
  payload: Partial<IUser>;
}

export interface IUserUpdateSettingsFailureAction {
  type: typeof USER_UPDATE_SETTINGS_FAILURE;
  payload: Error;
}

export interface IUserSocketConnectedAction {
  type: typeof USER_SOCKET_CONNECTED;
  payload: {};
}

export interface IUserSocketErrorAction {
  type: typeof USER_SOCKET_ERROR;
  payload: Error;
}

export interface IContentGetUserContentRequestAction {
  type: typeof CONTENT_GET_USERCONTENT_REQUEST;
}

export interface IContentGetUserContentSuccessAction {
  type: typeof CONTENT_GET_USERCONTENT_SUCCESS;
  payload: {
    pageInfo: PageInfo;
    // edges: IEdge<UserContent>[];
  };
}

export interface IContentGetUserContentFailureAction {
  type: typeof CONTENT_GET_USERCONTENT_FAILURE;
  payload: Error;
}

export interface IContentLoadPlayerContentRequestAction {
  type: typeof CONTENT_LOADPLAYERCONTENT_REQUEST;
  payload: {
    contentId: string;
  };
}

export interface IContentLoadPlayerContentSuccessAction {
  type: typeof CONTENT_LOADPLAYERCONTENT_SUCCESS;
  payload: {
    h5p: any;
  };
}

export interface IContentLoadPlayerContentFailureAction {
  type: typeof CONTENT_LOADPLAYERCONTENT_FAILURE;
  payload: Error;
}

export interface IContentDeleteRequestAction {
  type: typeof CONTENT_DELETE_REQUEST;
  payload: {
    contentIds: string[];
  };
}

export interface IContentDeleteSuccessAction {
  type: typeof CONTENT_DELETE_SUCCESS;
  payload: {
    contentIds: string[];
  };
}

export interface IContentDeleteFailureAction {
  type: typeof CONTENT_DELETE_FAILURE;
  payload: {
    error: Error;
    originalContentItems: any[];
  };
}

export interface IContentDownloadContentRequestAction {
  type: typeof CONTENT_DOWNLOADCONTENT_REQUEST;
  payload: {
    contentId: string;
  };
}

export interface IContentDownloadContentSuccessAction {
  type: typeof CONTENT_DOWNLOADCONTENT_SUCCESS;
  payload: {
    downloadUrl: string;
  };
}

export interface IContentDownloadContentFailureAction {
  type: typeof CONTENT_DOWNLOADCONTENT_FAILURE;
  errorCode: string;
}

export interface IContentGetContentRequestAction {
  type: typeof CONTENT_GET_CONTENT_REQUEST;
  payload: {
    contentId: string;
  };
}

export interface IContentGetContentSuccessAction {
  type: typeof CONTENT_GET_CONTENT_SUCCESS;
  payload: {
    // content: UserContent;
  };
}

export interface IContentGetContentFailureAction {
  type: typeof CONTENT_GET_CONTENT_FAILURE;
  payload: Error;
}

export interface IContentSetQueryAction {
  type: typeof CONTENT_SET_QUERY;
  payload: {
    query: string;
  };
}

export interface IDeploymentsGetRequestAction {
  type: typeof DEPLOYMENTS_GET_REQUEST;
  payload: {
    deploymentId: string;
  };
}

export interface IDeploymentsGetFailureAction {
  type: typeof DEPLOYMENTS_GET_FAILURE;
  payload: Error;
}

export interface IDeploymentsCreateUpdateRequestAction {
  type: typeof DEPLOYMENTS_CREATE_UPDATE_REQUEST;
  payload: {
    deploymentId?: string;
    contentId?: string;
    // input?: Partial<UserContent>;
  };
}

export interface IDeploymentsCreateUpdateFailureAction {
  type: typeof DEPLOYMENTS_CREATE_UPDATE_FAILURE;
  payload: Error;
}

export interface IDeploymentsGenerateSampleDataAction {
  type: typeof DEPLOYMENTS_GENERATESAMPLEDATA;
}

export interface IInsightsUpdateFilterAction {
  type: typeof INSIGHTS_UPDATE_FILTER;
  payload: {
    startDate: number;
    endDate: number;
    groupBy: string;
  };
}

export interface IContentExportRequestAction {
  type: typeof CONTENT_EXPORT_REQUEST;
  payload: {
    contentId: string;
    type: 'h5p' | 'htmlbundle' | 'htmlexternal' | 'scorm';
    options?: {
      showRights?: boolean;
      restrictWidthAndCenter?: boolean;
      masteryScore?: number;
      marginX?: number;
      marginY?: number;
      maxWidth?: number;
      showEmbed?: boolean;
    };
  };
}

export interface IContentExportUpdateAction {
  type: typeof CONTENT_EXPORT_UPDATE;
  payload: {
    progress: number;
  };
}

export interface IContentExportSuccessAction {
  type: typeof CONTENT_EXPORT_SUCCESS;
  payload: {
    downloadUrl: string;
  };
}

export interface IContentExportFailureAction {
  type: typeof CONTENT_EXPORT_FAILURE;
  payload: Error;
}

export interface IContentPublishRequestAction {
  type: typeof CONTENT_PUBLISH_REQUEST;
  payload: {
    contentId: string;
    license: string;
    language: string;
  };
}

export interface IContentPublishSuccessAction {
  type: typeof CONTENT_PUBLISH_SUCCESS;
  payload: {
    contentId: string;
    license: string;
    language: string;
  };
}

export interface IContentPublishFailureAction {
  type: typeof CONTENT_PUBLISH_FAILURE;
  payload: Error;
}

export interface IContentEditorGetContentRequestAction {
  type: typeof CONTENTEDITOR_GET_CONTENT_REQUEST;
  payload: {
    contentId: string;
  };
}

export interface IContentEditorOnSaveErrorAction {
  type: typeof CONTENTEDITOR_ONSAVEERROR;
  payload: {
    contentId: string;
    error: Error;
  };
}

export interface IContentEditorOnLoadedAction {
  type: typeof CONTENTEDITOR_ONLOADED;
  payload: {
    contentId: string;
  };
}

export interface IContentEditorOnSavedAction {
  type: typeof CONTENTEDITOR_ONSAVED;
  payload: {
    contentId: string;
  };
}

export interface IContentEditorGetContentSuccessAction {
  type: typeof CONTENTEDITOR_GET_CONTENT_SUCCESS;
  payload: {
    content: any;
  };
}

export interface IContentEditorGetContentFailureAction {
  type: typeof CONTENTEDITOR_GET_CONTENT_FAILURE;
  errorCode: string;
}

export interface IContentUnpublishRequestAction {
  type: typeof CONTENT_UNPUBLISH_REQUEST;
  payload: {
    contentId: string;
  };
}

export interface IContentUnpublishSuccessAction {
  type: typeof CONTENT_UNPUBLISH_SUCCESS;
}

export interface IContentUnpublishFailureAction {
  type: typeof CONTENT_UNPUBLISH_FAILURE;
  payload: Error;
}

export interface IContentEditorUpdateContentAction {
  type: typeof CONTENTEDITOR_UPDATE_CONTENT;
  payload: {
    content: any;
  };
}

export interface IContentEditorSetShowExportDialogAction {
  type: typeof CONTENTEDITOR_SETSHOWEXPORTDIALOG;
  payload: {
    showExportDialog: boolean;
  };
}

export interface IContentEditorResetContentAction {
  type: typeof CONTENTEDITOR_RESETCONTENT;
}

export interface IContentEditorLoadContentRequestAction {
  type: typeof CONTENTEDITOR_LOADEDITORCONTENT_REQUEST;
  payload: {
    contentId: string;
  };
}

export interface IContentEditorLoadContentSuccessAction {
  type: typeof CONTENTEDITOR_LOADEDITORCONTENT_SUCCESS;
  payload: {
    content: string;
    contentHash: string;
  };
}

export interface IContentEditorLoadContentFailureAction {
  type: typeof CONTENTEDITOR_LOADEDITORCONTENT_FAILURE;
  errorCode: string;
}

export interface IContentEditorUpdateEditorContentRequestAction {
  type: typeof CONTENTEDITOR_UPDATEEDITORCONTENT_REQUEST;
  payload: {
    contentId: string;
    h5p: any;
    published: boolean;
    language: string;
    license: string;
    keywords: string[];
  };
}

export interface IContentEditorUpdateEditorContentSuccessAction {
  type: typeof CONTENTEDITOR_UPDATEEDITORCONTENT_SUCCESS;
  payload: {
    contentId: string;
    content: any;
    lastSavedContentHash: string;
  };
}

export interface IContentEditorUpdateEditorContentFailureAction {
  type: typeof CONTENTEDITOR_UPDATEEDITORCONTENT_FAILURE;
  payload: Error;
}
export interface IFlowGetFlowRequestAction {
  type: typeof FLOW_GETFLOW_REQUEST;
  payload: {
    flowId: string;
  };
}

export interface IFlowGetFlowSuccessAction {
  type: typeof FLOW_GETFLOW_SUCCESS;
  payload: {};
}

export interface IFlowGetFlowFailureAction {
  type: typeof FLOW_GETFLOW_FAILURE;
  payload: Error;
}

export interface IFlowDeleteContentIdAction {
  type: typeof FLOW_DELETECONTENTID;
  payload: {
    contentId: string;
  };
}

export interface IFlowCreateFlowRequestAction {
  type: typeof FLOW_CREATEFLOW_REQUEST;
  payload: {
    title: string;
    description: string;
    coverImage: string;
  };
}

export interface IFlowCreateFlowSuccessAction {
  type: typeof FLOW_CREATEFLOW_SUCCESS;
  payload: {
    flow: any;
  };
}

export interface IFlowCreateFlowFailureAction {
  type: typeof FLOW_CREATEFLOW_FAILURE;
  payload: Error;
}

export interface IFlowUpdateFlowRequestAction {
  type: typeof FLOW_UPDATEFLOW_REQUEST;
  payload: {
    flowId: string;
    title: string;
    description: string;
    coverImage: string;
  };
}

export interface IFlowUpdateFlowSuccessAction {
  type: typeof FLOW_UPDATEFLOW_SUCCESS;
  payload: {
    flow: any;
  };
}

export interface IFlowUpdateFlowFailureAction {
  type: typeof FLOW_UPDATEFLOW_FAILURE;
  payload: Error;
}

export interface IFlowDeleteFlowRequestAction {
  type: typeof FLOW_DELETEFLOW_REQUEST;
  payload: {
    flowId: string;
  };
}

export interface IFlowDeleteFlowSuccessAction {
  type: typeof FLOW_DELETEFLOW_SUCCESS;
  payload: {
    flowId: string;
  };
}

export interface IFlowDeleteFlowFailureAction {
  type: typeof FLOW_DELETEFLOW_FAILURE;
  payload: Error;
}

export interface IFlowGetFlowPageRequestAction {
  type: typeof FLOW_GETFLOWPAGE_REQUEST;
  payload: {
    query: string;
    currentPage: number;
  };
}

export interface IFlowGetFlowPageSuccessAction {
  type: typeof FLOW_GETFLOWPAGE_SUCCESS;
  payload: {
    pageInfo: PageInfo;
    edges: IEdge<any>[];
  };
}

export interface IFlowGetFlowPageFailureAction {
  type: typeof FLOW_GETFLOWPAGE_FAILURE;
  payload: Error;
}

export interface IFlowAddContentIdAction {
  type: typeof FLOW_ADDCONTENTID;
  payload: {
    contentId: string;
  };
}

export interface IFlowSetPreviewContentIdAction {
  type: typeof FLOW_SETPREVIEWCONTENTID;
  payload: {
    contentId: string;
  };
}

export interface IFlowResetFlowAction {
  type: typeof FLOW_RESETFLOW;
}

export interface IFlowSetTabAction {
  type: typeof FLOW_SETTAB;
  payload: {
    tab: string;
  };
}

export interface IFlowSetQueryAction {
  type: typeof FLOW_SETQUERY;
  payload: {
    query: string;
  };
}

export interface IFlowPersistContentIdsAction {
  type: typeof FLOW_PERSISTCONTENTIDS;
  payload: {
    contentIds: string[];
  };
}

export interface IFlowSelectContentIdAction {
  type: typeof FLOW_SELECTCONTENTID;
  payload: {
    contentId: string;
  };
}

export interface IFlowMoveContentIdUpwardAction {
  type: typeof FLOW_MOVECONTENTIDUPWARD;
  payload: {
    contentId: string;
  };
}

export interface IFlowMoveContentIdDownwardAction {
  type: typeof FLOW_MOVECONTENTIDDOWNWARD;
  payload: {
    contentId: string;
  };
}

export interface IFlowUpdateFlowAction {
  type: typeof FLOW_UPDATEFLOW;
  payload: {
    title?: string;
    description?: string;
    coverImage?: string;
  };
}

export interface IPublicContentGetPageRequestAction {
  type: typeof PUBLICCONTENT_GETPAGE_REQUEST;
  payload: {
    query: string;
    currentPage: number;
    filter: {
      language: string[];
      contentType: string[];
      license: string[];
    };
  };
}

export interface IPublicContentGetPageSuccessAction {
  type: typeof PUBLICCONTENT_GETPAGE_SUCCESS;
  payload: {
    pageInfo: PageInfo;
  };
}

export interface IPublicContentGetPageFailureAction {
  type: typeof PUBLICCONTENT_GETPAGE_FAILURE;
  payload: Error;
}

export interface IPublicContentToggleFilterSidebarAction {
  type: typeof PUBLICCONTENT_TOGGLEFILTERSIDEBAR;
}

export interface IPublicContentSetFilterAction {
  type: typeof PUBLICCONTENT_SETFILTER;
  payload: {
    query?: string;
    filter: {
      language?: string[];
      contentType?: string[];
      license?: string[];
      sort?: string;
    };
  };
}

export interface INotificationsRemoveAction {
  type: typeof NOTIFICATIONS_REMOVE;
  payload: {
    key: string;
  };
}

export interface INotificationsDismissAction {
  type: typeof NOTIFICATIONS_DISMISS;
  payload: {
    key: string;
  };
}

export interface IJobsGetJobFailureAction {
  type: typeof JOBS_GETJOB_FAILURE;
  errorCode: string;
}

export interface IUIResetErrorsAction {
  type: typeof UI_RESET_ERRORS;
}

export interface IUIChangeLanguageAction {
  type: typeof UI_CHANGE_LANGUAGE;
  payload: {
    language: string;
  };
}

export interface IRunGetRequestAction {
  type: typeof RUN_GET_REQUEST;
  payload: {
    runId: string;
  };
}

export interface IRunGetSuccessAction {
  type: typeof RUN_GET_SUCCESS;
  payload: {
    run: any;
  };
}

export interface IRunGetFailureAction {
  type: typeof RUN_GET_FAILURE;
  payload: Error;
}

export interface IRunCreateUpdateRequestAction {
  type: typeof RUN_CREATE_UPDATE_REQUEST;
  payload: {
    runId?: string;
    contentId?: string;
    input?: any;
  };
}

export interface IRunCreateUpdateSuccessAction {
  type: typeof RUN_CREATE_UPDATE_SUCCESS;
  payload: {
    run: any;
  };
}

export interface IRunCreateUpdateFailureAction {
  type: typeof RUN_CREATE_UPDATE_FAILURE;
  payload: Error;
}

export interface IRunGetAnalyticsRequestAction {
  type: typeof RUN_GET_ANALYTICS_REQUEST;
  payload: {
    runId: string;
  };
}

export interface IRunGetAnalyticsSuccessAction {
  type: typeof RUN_GET_ANALYTICS_SUCCESS;
  payload: {
    users: any[];
    answers: any[];
    interactions: any[];
    contentId: string;
  };
}

export interface IRunGetAnalyticsFailureAction {
  type: typeof RUN_GET_ANALYTICS_FAILURE;
  payload: Error;
}

export interface IRunUpdatePausedAction {
  type: typeof RUN_UPDATE_PAUSED;
  payload: {
    paused: boolean;
  };
}

export interface IRunXAPIStatementReceivedAction {
  type: typeof RUN_XAPI_STATEMENT_RECEIVED;
  payload: any;
}

export interface IRunAddUserAction {
  type: typeof RUN_ADD_USER;
  payload: {
    user: any;
  };
}

export interface IRunUpdateUserAction {
  type: typeof RUN_UPDATE_USER;
  payload: {
    userId: string;
    name: string;
  };
}

export interface IRunAddAnswerAction {
  type: typeof RUN_ADD_ANSWER;
  payload: any;
}

export type ActionTypes =
  | IAuthLoginRequestAction
  | IAuthLoginFailureAction
  | IAuthLoginSuccessAction
  | IAuthRegisterRequestAction
  | IAuthRegisterSuccessAction
  | IAuthRegisterFailureAction
  | IAutLogoutRequestAction
  | IAutLogoutSuccessAction
  | IAutLogoutFailureAction
  | IAuthGetSessionRequestAction
  | IAuthGetSessionSuccessAction
  | IAuthGetSessionFailureAction
  | IAuthResendEmailVerificationRequestAction
  | IAuthResendEmailVerificationSuccessAction
  | IAuthResendEmailVerificationFailureAction
  | IAuthVerifyEmailRequestAction
  | IAuthVerifyEmailSuccessAction
  | IAuthVerifyEmailFailureAction
  | IAuthRefreshTokenRequestAction
  | IAuthRefreshTokenSuccessAction
  | IAuthRefreshTokenFailureAction
  | IOnboardingStartTourAction
  | IOnboardingNextStepAction
  | IOnboardingPrevStepAction
  | IOnboardingCloseTourAction
  | IOnboardingInitAction
  | IOnboardingSetTourAction
  | ISubscriptionCancelRequestAction
  | ISubscriptionCancelSuccessAction
  | ISubscriptionCancelFailureAction
  | ISubscriptionGetRequestAction
  | ISubscriptionGetSuccessAction
  | ISubscriptionGetFailureAction
  | ISubscriptionResumeRequestAction
  | ISubscriptionResumeSuccessAction
  | ISubscriptionResumeFailureAction
  | ISubscriptionToggleIntervalAction
  | ISubscriptionLinkRequestAction
  | ISubscriptionLinkSuccessAction
  | ISubscriptionLinkFailureAction
  | ISubscriptionUnlinkRequestAction
  | ISubscriptionUnlinkSuccessAction
  | ISubscriptionUnlinkFailureAction
  | ISubscriptionDataPopupClosedAction
  | IUserUpdateSettingsRequestAction
  | IUserUpdateSettingsSuccessAction
  | IUserUpdateSettingsFailureAction
  | IContentGetUserContentRequestAction
  | IContentGetUserContentSuccessAction
  | IContentGetUserContentFailureAction
  | IContentDeleteRequestAction
  | IContentDeleteSuccessAction
  | IContentDeleteFailureAction
  | IContentGetContentRequestAction
  | IContentGetContentSuccessAction
  | IContentGetContentFailureAction
  | IContentSetQueryAction
  | IDeploymentsGetRequestAction
  | IDeploymentsGetFailureAction
  | IDeploymentsCreateUpdateRequestAction
  | IDeploymentsCreateUpdateFailureAction
  | IDeploymentsGenerateSampleDataAction
  | IInsightsUpdateFilterAction
  | IContentExportRequestAction
  | IContentExportUpdateAction
  | IContentExportSuccessAction
  | IContentExportFailureAction
  | IContentPublishRequestAction
  | IContentPublishSuccessAction
  | IContentPublishFailureAction
  | IContentUnpublishRequestAction
  | IContentUnpublishSuccessAction
  | IContentUnpublishFailureAction
  | IContentEditorGetContentRequestAction
  | IContentEditorGetContentSuccessAction
  | IContentEditorGetContentFailureAction
  | IContentEditorUpdateContentAction
  | IContentEditorSetShowExportDialogAction
  | IContentEditorResetContentAction
  | IFlowGetFlowRequestAction
  | IFlowGetFlowSuccessAction
  | IFlowGetFlowFailureAction
  | IFlowDeleteContentIdAction
  | IFlowCreateFlowRequestAction
  | IFlowCreateFlowSuccessAction
  | IFlowCreateFlowFailureAction
  | IFlowUpdateFlowRequestAction
  | IFlowUpdateFlowSuccessAction
  | IFlowUpdateFlowFailureAction
  | IFlowDeleteFlowRequestAction
  | IFlowDeleteFlowSuccessAction
  | IFlowDeleteFlowFailureAction
  | IFlowGetFlowPageRequestAction
  | IFlowGetFlowPageSuccessAction
  | IFlowGetFlowPageFailureAction
  | IFlowAddContentIdAction
  | IFlowSetPreviewContentIdAction
  | IFlowResetFlowAction
  | IFlowSetTabAction
  | IFlowSetQueryAction
  | IFlowPersistContentIdsAction
  | IFlowSelectContentIdAction
  | IFlowMoveContentIdUpwardAction
  | IFlowMoveContentIdDownwardAction
  | IFlowUpdateFlowAction
  | IPublicContentGetPageRequestAction
  | IPublicContentGetPageSuccessAction
  | IPublicContentGetPageFailureAction
  | IPublicContentToggleFilterSidebarAction
  | IPublicContentSetFilterAction
  | INotificationsDismissAction
  | IContentLoadPlayerContentRequestAction
  | IContentLoadPlayerContentSuccessAction
  | IContentLoadPlayerContentFailureAction
  | IContentEditorLoadContentRequestAction
  | IContentEditorLoadContentSuccessAction
  | IContentEditorLoadContentFailureAction
  | IContentEditorUpdateEditorContentRequestAction
  | IContentEditorUpdateEditorContentSuccessAction
  | IContentEditorUpdateEditorContentFailureAction
  | IContentDownloadContentRequestAction
  | IContentDownloadContentSuccessAction
  | IContentDownloadContentFailureAction
  | IUIResetErrorsAction
  | IUIChangeLanguageAction
  | IUserSocketConnectedAction
  | IUserSocketErrorAction
  | IWebsocketOnConnectAction
  | IWebsocketOnErrorAction
  | IWebsocketConnectRequestAction
  | IWebsocketJoinSuccessAction
  | IWebsocketLeaveSuccessAction
  | IAppGetSignedUploadUrlRequestAction
  | IAppGetSignedUploadUrlSuccessAction
  | IAppGetSignedUploadUrlFailureAction
  | IFoldersSetCurrentFolderAction
  | IFoldersCreateFolderRequestAction
  | IFoldersCreateFolderSuccessAction
  | IFoldersCreateFolderFailureAction
  | IFoldersDeleteFolderRequestAction
  | IFoldersDeleteFolderSuccessAction
  | IFoldersDeleteFolderFailureAction
  | IFoldersSelectFolderAction
  | IFoldersSelectContentAction
  | IFoldersOpenEditDialogAction
  | IFoldersUpdateFolderRequestAction
  | IFoldersUpdateFolderSuccessAction
  | IFoldersUpdateFolderFailureAction
  | IFoldersCloseEditDialogAction
  | IFoldersSelectAllInCurrentFolderAction
  | IFoldersUpdateFolderRequestAction
  | IFoldersUpdateFolderSuccessAction
  | IFoldersUpdateFolderFailureAction
  | IFoldersOpenEditDialogAction
  | IFoldersSelectFolderAction
  | IFoldersSelectContentAction
  | IFoldersCreateFolderRequestAction
  | IFoldersCreateFolderSuccessAction
  | IFoldersCreateFolderFailureAction
  | IFoldersSetCurrentFolderAction
  | IFoldersDeleteFolderRequestAction
  | IFoldersDeleteFolderSuccessAction
  | IFoldersDeleteFolderFailureAction
  | IFoldersSelectAllInCurrentFolderAction
  | IFoldersCloseEditDialogAction
  | IFoldersUpdateFolderRequestAction
  | IFoldersUpdateFolderSuccessAction
  | IFoldersUpdateFolderFailureAction
  | IFoldersOpenEditDialogAction
  | IFoldersSelectFolderAction
  | IFoldersSelectContentAction
  | IFoldersCreateFolderRequestAction
  | IContentSelectContentAction
  | IContentUnselectContentAction
  | IContentSetSelectedContentAction
  | IFoldersAddContentToFolderAction
  | IUIShowDialogAction
  | IUIHideDialogAction
  | IFoldersRemoveContentFromFolderAction
  | IUINavigateAction
  | IFoldersGetFoldersRequestAction
  | IFoldersGetFoldersSuccessAction
  | IFoldersGetFoldersFailureAction
  | IFoldersGetUserRootFoldersRequestAction
  | IFoldersGetUserRootFoldersSuccessAction
  | IFoldersGetUserRootFoldersFailureAction
  | IFoldersFolderCreatedAction
  | IFoldersSetEditFolderAction
  | IFoldersDeleteSuccessAction
  | IFolderCreateRequestAction
  | IFolderCreateSuccessAction
  | IFolderCreateFailureAction
  | IFolderUpdateSuccessAction
  | IFoldersSetSelectedFoldersAction
  | IFoldersCreateSuccessAction
  | IFoldersRemoveContentSuccessAction
  | IFoldersAddContentToFolderSuccessAction
  | IDeploymentUpdateAction
  | IUserDeleteAccountSuccessAction
  | IUserChangePasswordSuccessAction
  | IUserChangeEmailSuccessAction
  | IUserUpdateEmailPreferenceSuccessAction
  | IFoldersSetFolderIdToAddContentAction
  | IUISetViewAction
  | IUIClipboardCutAction
  | IFoldersCutAndPasteRequestAction
  | IFoldersCutAndPasteSuccessAction
  | IFoldersCutAndPasteFailureAction
  | IContentEditorOpenAction
  | IContentEditorCloseAction
  | IContentEditorSetContentParamsAction
  | IUpdateContentDownload
  | WorkspaceActionTypes
  | IAppInitRequestAction
  | IAppInitSuccessAction
  | IAppInitFailureAction
  | IRunGetRequestAction
  | IRunGetSuccessAction
  | IRunGetFailureAction
  | IRunCreateUpdateRequestAction
  | IRunCreateUpdateSuccessAction
  | IRunCreateUpdateFailureAction
  | IRunGetAnalyticsRequestAction
  | IRunGetAnalyticsSuccessAction
  | IRunGetAnalyticsFailureAction
  | IRunUpdatePausedAction
  | IRunXAPIStatementReceivedAction
  | IRunAddUserAction
  | IRunUpdateUserAction
  | IRunAddAnswerAction
  | AppActionTypes
  | ContentBrowserActionTypes
  | H5PEditorActionTypes;
